import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, Label } from 'semantic-ui-react';
import { format } from 'date-fns';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';

class DiscountRulesList extends React.Component {
  renderTableContent() {
    const { isLoading, discountRules } = this.props;

    if (isLoading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="8">
            <LoadingSpinner />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (discountRules.length === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="8" style={{ textAlign: 'center' }}>
            No discount rules found
          </Table.Cell>
        </Table.Row>
      );
    }

    return discountRules.map(this.renderTableRow.bind(this));
  }

  renderTableRow(rule) {
    const { onEditRule, onDeleteRule } = this.props;
    const monthsLeft = rule.subscription_period_months_left;
    const monthsDisplay =
      monthsLeft != null && monthsLeft !== -1
        ? `≤ ${monthsLeft} month${monthsLeft === 1 ? '' : 's'}`
        : '-';

    return (
      <Table.Row key={rule.id}>
        <Table.Cell>
          <Label color="blue">Renewal</Label>
        </Table.Cell>
        <Table.Cell>{monthsDisplay}</Table.Cell>
        <Table.Cell>{rule.discount_percentage}%</Table.Cell>
        <Table.Cell>{rule.priority}</Table.Cell>
        <Table.Cell>
          <Label color="green">All Packages</Label>
        </Table.Cell>
        <Table.Cell>
          {rule.created_at
            ? format(new Date(rule.created_at), 'yyyy-MM-dd HH:mm:ss')
            : '-'}
        </Table.Cell>
        <Table.Cell>
          <Icon
            name="pencil"
            link
            color="blue"
            onClick={() => onEditRule(rule)}
            style={{ marginRight: '1em', cursor: 'pointer' }}
          />
          <Icon
            name="trash"
            link
            color="red"
            onClick={() => onDeleteRule(rule)}
            style={{ cursor: 'pointer' }}
          />
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Discount Type</Table.HeaderCell>
            <Table.HeaderCell>Months Left Rule</Table.HeaderCell>
            <Table.HeaderCell>Discount %</Table.HeaderCell>
            <Table.HeaderCell>Priority</Table.HeaderCell>
            <Table.HeaderCell>Applies To</Table.HeaderCell>
            <Table.HeaderCell>Created</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderTableContent()}</Table.Body>
      </Table>
    );
  }
}

DiscountRulesList.propTypes = {
  discountRules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      discount_percentage: PropTypes.number,
      priority: PropTypes.number,
      subscription_period_months_left: PropTypes.number,
      creator_email: PropTypes.string,
      created_at: PropTypes.string,
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onEditRule: PropTypes.func.isRequired,
  onDeleteRule: PropTypes.func.isRequired,
};

export default DiscountRulesList;
